export const PRODUCTS_ALL = "/products/all";
export const PRODUCTS_USLUGA_URL = "/products/usluga";
